<ion-button color="validation" shape="round" [ngClass]="{'disable': isDisable}" (click)="params.onTap()"
	class="toolbar btn-fab" [ngStyle]="params.inlineCssRender" data-cy="fab-button">
	<span class="button-inner" title="{{params.name}}">
		<ion-icon [name]="params.icon" class="icone"></ion-icon>
	</span>
</ion-button>